export default (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M28 16.0733C28 9.40541 22.6274 4 16 4C9.37258 4 4 9.40541 4 16.0733C4 22.0995 8.38823 27.0943 14.125 28V19.5633H11.0781V16.0733H14.125V13.4134C14.125 10.3875 15.9165 8.71615 18.6576 8.71615C19.9705 8.71615 21.3438 8.95195 21.3438 8.95195V11.9231H19.8306C18.3399 11.9231 17.875 12.8538 17.875 13.8086V16.0733H21.2031L20.6711 19.5633H17.875V28C23.6118 27.0943 28 22.0995 28 16.0733Z"
  />
);
